module.exports = __webpack_public_path__ + "static/media/color-restraint.6716c6ef.svg";